import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Box, Chip, LinearProgress, Stack, Typography } from '@mui/material';
import {removesuccess,remove} from './venteSlice';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Apercu({Show,toggleApercu ,currentVente}) {
  
    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
          backgroundColor: theme.palette.common.black,
          color: theme.palette.common.white,
        },
        [`&.${tableCellClasses.body}`]: {
          fontSize: 14,
        },
      }));

        const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  }));

  const userData = useSelector(state => state.userData)
  const id = userData.id;
  const apitoken = userData.apitoken;
  const apiUrl = process.env.REACT_APP_API_URL;

  const venteData=useSelector(state => state.PdanewventeData);
  const removeSuccess = venteData.removeSuccess
  const [Progession, setProgession] = useState(false);

  const dispatch= useDispatch();
  const navigate = useNavigate();

  const GetFacture = async (idvente) =>{
    try {
        const response = await axios.get(`${apiUrl}generer/ticket/${id}/${apitoken}/${idvente}`,
          {
          responseType: 'blob',
        });
        // Créez un lien pour télécharger le PDF
        const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download',`Ticket.pdf`);
        document.body.appendChild(link);
        link.click();
        toggleApercu()
    }
        catch (error) {
            console.error('Error generating fsortie:', error);
          }
}
    
      function ShowPromoList(){
        if(currentVente.promotions.length>0){
          return currentVente.promotions.map(promo =>{
            return(
              <StyledTableRow key={promo._id}>
              <StyledTableCell component="th" scope="row">
              <Typography variant="h5" color="primary">
              {promo.nom_promo}
              </Typography>
              <Typography variant="h6" color="secondary">
              {promo.designation}
              </Typography>
              <Box>
              <Chip label={`PACKS : ${promo.qtepromo}`} />
                
              </Box>
              </StyledTableCell>
              </StyledTableRow>       
            )
          })

        }
        else {
          return (
            <StyledTableRow>
            <StyledTableCell align='center'  component="th" scope="row">
            Aucune promotion
            </StyledTableCell>
          </StyledTableRow>
          )
        }
      }
      function ShowList() {

        const listFiltre = currentVente.produits?.filter(chargement => chargement.pack>0 || chargement.unite >0 )
        return(
            listFiltre.map(chargement =>{
                return(

                    <StyledTableRow key={chargement._id}>
                    <StyledTableCell component="th" scope="row">
                    <Typography variant="h6" color="secondary">
                    {chargement.designation}
                    </Typography>
                    <Box>
                    <Chip label={`PACKS : ${chargement.pack}`} />
                    <Chip sx={{marginLeft:'5px'}} label={`UNITES : ${chargement.unite}`} />
                      
                    </Box>
                    </StyledTableCell>
                    </StyledTableRow>
                )
            })
        )
    }

    const suppression = async (idvente,type)=> {
      let valeur = "vente"
      if(type === "prevente") {
        valeur = "prevente"
      }
      setProgession(true)
      
      try {
          const apiUrl = process.env.REACT_APP_API_URL;
          const response = await axios.post(`${apiUrl}delete/vente/${id}/${apitoken}/${idvente}/${valeur}`,
            {
              timeout: 20000,
            }
          );
          if(response.data.status==="ok")
              {
                  dispatch(remove(idvente));
                  dispatch(removesuccess(true));
              }
              else {
                alert("Journée clôturée")
              }
      } catch (error) {
        // navigate('/');
      }
      setProgession(false)
      toggleApercu()
  }


    const supprimer = (id,type) => {
      let result = window.confirm(`Supprimer la vente ?`);
      if (result === true) {
          suppression(id,type);
      }
    }
  return (
    <>
    <Dialog
    open={Show}
    onClose={toggleApercu}
    >
              { Progession ?
    <Box >
  <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
        <LinearProgress color="success" />
      </Stack>
    </Box>
            :
            ''
            }
    <DialogTitle align='center'>Aperçu</DialogTitle>
    <DialogContent>
    <DialogContentText align='center'>
          Liste des produits
          </DialogContentText>
          <TableContainer sx={{ marginTop: '20px' }} component={Paper}>
          
      <Table sx={{ width: 400 }} aria-label="customized table">
        <TableHead>
          <TableRow>
            <StyledTableCell>Produits</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <ShowList/>
          <StyledTableRow>
          <StyledTableCell component="th" scope="row" align="center">
          <Typography variant="h7" align='center' color="secondary">
            TOTAL : {
              (currentVente.etat === "Espèce" || currentVente.etat === "Crédit")
                ? (currentVente.total ? (currentVente.total * 1.0025).toFixed(2) : 0)
                : currentVente.total?.toFixed(2)
            } Dhs
            </Typography>
            </StyledTableCell>
        </StyledTableRow>
        </TableBody>
      </Table>
    </TableContainer>
    <TableContainer sx={{ marginTop: '20px' }} component={Paper}>
          
          <Table sx={{ width: 400 }} aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell>Promotions</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <ShowPromoList/>
            </TableBody>
          </Table>
        </TableContainer>
    </DialogContent>
    <DialogActions>
    <Button color="success"  onClick={() => GetFacture(currentVente._id)}>Imprimer</Button>
    { Progession ?

<Button color="error" disabled >Supprimer</Button>
            :
<Button color="error"  onClick={() => supprimer(currentVente._id,currentVente.type)}>Supprimer</Button>
            }
    
    <Button color="secondary" onClick={toggleApercu}>Fermer</Button>
    </DialogActions>
    </Dialog>  
    </> 
  )
}